export default {
   data () {
    return {}
   },
   mounted() {},
   created: function () {},
   methods: {
     getAllAdm(){
        this.setSpinnerStatus(true)
        const response = this.axios.get('/ccb/auth/fe/country/admList', {...this.authHeader})
        .then((result) => result.data)
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
        .finally(e => {
          this.setSpinnerStatus(false)
        });
        return response;
      }
   }  
}